export namespace NstiStockConstants {

    export enum DateFormat {
        DateFormat = 'YYYY-MM-DD',
        DateTimeFormat = 'YYYY-MM-DD HH:mm:ss'
    }

    export enum Status {
        TEMP = 'TEMP',
        DRAFT = 'DRAFT',
        FINAL = 'FINAL'
    }
    export enum NstiType {
        NON_STOCK = 'NON_STOCK',
        TRADE_IN = 'TRADE_IN',
    }
    export enum TransType {
        ADJUSTMENT = 'ADJUSTMENT',
        DISPOSAL = 'DISPOSAL',
        ACQUISITION = 'ACQUISITION'
    }
} 